import Icon from '../components/Icon.vue'

Icon.register({
  'drafting-compass': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M457 344.4l55 95.2-7 58.3c-1.3 10.6-12.4 17-22.2 12.8l-54-23-54.4-94.2c29.9-11.9 57.5-28.7 82.5-49zM499.5 249.9c-52.6 83.1-144.4 134.1-243.5 134.1-35.4 0-69.9-6.7-102.1-19l-70.8 122.6-53.9 23c-9.8 4.2-20.9-2.2-22.2-12.8l-7-58.3 71.3-123.5c-21.3-17.8-40.4-38.4-56-62-5-7.6-2.2-17.9 5.6-22.5l27.8-16.1c7.4-4.3 16.6-1.8 21.4 5.3 9.7 14.4 21.1 27.4 33.7 39l68.3-118.3c-7.4-13.6-12-29-12-45.7 0-53 43-96 96-96s96 43 96 96c0 16.6-4.6 32-12.1 45.7l51.8 89.7c-23.1 23.2-51.4 40-82.6 48.9l-51.1-88.5c-0.7 0-1.3 0.2-2 0.2s-1.3-0.2-2-0.2l-67.4 116.7c22.2 7.3 45.5 11.5 69.4 11.5 76.3 0 147-38.8 188.1-102.4 4.6-7.2 13.8-9.9 21.3-5.7l28.1 15.6c7.9 4.4 10.9 14.7 6 22.4zM256 64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/drafting-compass.js
// module id = 1285
// module chunks = 0